export enum HeadsUpIconAlignment {
  TOP = 'top',
  MIDDLE = 'middle',
}
